import { createFileRoute } from "@tanstack/react-router";
import AdminTagsPage from "@/pages/admin/tags";

export const Route = createFileRoute("/app/admin/tags")({
  component: AdminTagsPage,
});
